<script setup lang="ts">
import { storeToRefs } from "pinia";
import ActionStatusBtn from "~/components/Pages/training-plan/project/steps/project-type/ActionStatusBtn.vue";
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import { TrainingTypeEnum } from "~/utils/enums/training.enums";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import InternalBuilderChoiceModal from "./InternalBuilderChoiceModal.vue";

const createTrainingStore = useCreateTrainingStore();
const { training } = storeToRefs(createTrainingStore);
const isOpenChoiceInternal = ref(false);

const openChoiceInternal = () => {
  isOpenChoiceInternal.value = true;
};
</script>

<template>
  <button type="button" class="absolute top-0 right-0 p-3" @click="createTrainingStore.showModal = false">
    <SvgIcon class="h-[24px] w-[24px] text-secondary-color" name="close"></SvgIcon>
  </button>

  <Transition name="slide-up" mode="out-in">
    <div v-if="!isOpenChoiceInternal">
      <h3 class="heading_3_demi p-[8px] mb-[16px]">Que souhaitez-vous faire ?</h3>
      <div class="grid px-4">
        <div class="flex flex-col justify-between gap-2 gap-x-2 pb-4">
          <ActionStatusBtn @click="training.general.type = TrainingTypeEnum.EXTERNAL">
            <template #title>
              <SvgIcon class="h-[24px] w-[24px] text-secondary-color" name="briefcase"></SvgIcon>
              Ajouter une formation externe
            </template>
          </ActionStatusBtn>
          <ActionStatusBtn @click="openChoiceInternal">
            <template #title>
              <SvgIcon class="h-[24px] w-[24px] text-secondary-color" name="student"></SvgIcon>
              Créer une formation interne
            </template>
          </ActionStatusBtn>
        </div>
      </div>
    </div>
    <InternalBuilderChoiceModal v-else></InternalBuilderChoiceModal>
  </Transition>
</template>

<style scoped lang="scss">
@use "assets/scss/texts";

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.2s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
